import React from 'react';
import { ISVGType } from './SVGType';

const SmartContractIcon = (props: ISVGType) => {
  const { height = 42, width = 42 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
    >
      <rect opacity="0.3" width="42" height="42" rx="10" fill="#4FA0CD" fillOpacity="0.384314" />
      <mask id="mask0_681_13937" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="11" y="11" width="20" height="20">
        <rect x="11" y="11" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_681_13937)">
        <path
          d="M12.6667 16V11.8333H16.8333V13.5H14.3333V16H12.6667ZM27.6667 16V13.5H25.1667V11.8333H29.3333V16H27.6667ZM12.6667 30.1667V26H14.3333V28.5H16.8333V30.1667H12.6667ZM25.1667 30.1667V28.5H27.6667V26H29.3333V30.1667H25.1667ZM16.8333 26H25.1667V16H16.8333V26ZM16.8333 27.6667C16.375 27.6667 15.9826 27.5035 15.6562 27.1771C15.3299 26.8507 15.1667 26.4583 15.1667 26V16C15.1667 15.5417 15.3299 15.1493 15.6562 14.8229C15.9826 14.4965 16.375 14.3333 16.8333 14.3333H25.1667C25.625 14.3333 26.0174 14.4965 26.3437 14.8229C26.6701 15.1493 26.8333 15.5417 26.8333 16V26C26.8333 26.4583 26.6701 26.8507 26.3437 27.1771C26.0174 27.5035 25.625 27.6667 25.1667 27.6667H16.8333ZM18.5 19.3333H23.5V17.6667H18.5V19.3333ZM18.5 21.8333H23.5V20.1667H18.5V21.8333ZM18.5 24.3333H23.5V22.6667H18.5V24.3333Z"
          fill="#4FA0CD"
        />
      </g>
    </svg>
  );
};

export default SmartContractIcon;
